import { Component, OnInit } from "@angular/core";
import { ConfigurationControlService } from './../../services/configuration/configurationControl.service';

declare var $:any;

@Component({
    selector: 'app-accesibilidad',
    templateUrl: './accesibilidad.component.html',
    styleUrls: ['./accesibilidad.component.css']
})
export class AccesibilidadComponent{
    
    constructor(private _configurationControlService: ConfigurationControlService){      
    }
    
}